<template>
  <div>
    <service-intro
      :title="trans('assessments.title')"
      :description="trans('assessments.welcome')"
      service-image="/images/illustrations/become360_1.svg"
      container-image="/images/bg_pink.svg"
      :current-page="trans('assessments.title')"
      prev-page="home"
      :prev-page-link="{ name: 'servicedashboard' }"
    >
      <h5 v-if="assessmentsAvailable" class="text-primary mt-5 mb-4">
        {{ trans("assessments.evaluations") }}
      </h5>

      <assessments-cards
        v-if="assessmentsAvailable"
        :statusFirstTest="this.statusFirstTest"
        :statusSecondTest="this.statusSecondTest"
        :dateCompletedFirst="this.dateCompletedFirst"
        :dateCompletedSecond="this.dateCompletedSecond"
        :autoLoginUrl="this.autoLoginUrl"
        :isSecondTestAvailable="this.isSecondTestAvailable"
      />

      <div class="row">
        <div class="col-12 text-right">
          <div class="logo-cfcc-small mt-3 d-inline-flex p-2">
            <p class="mb-1 caption text-disabled">In collaborazione con:</p>
            <b-img src="/images/CFCC_logo_1.png" />
          </div>
        </div>
      </div>
    </service-intro>

    <b-container>
      <div class="row align-items-center pt-5 pb-5">
        <div class="col-12 col-md-5">
          <b-img src="/images/illustrations/become360_2.svg" fluid />
        </div>
        <div class="col-12 col-md-7">
          <h5 class="text-primary">
            {{ trans("assessments.soft_skills") }}
          </h5>
          <p>{{ trans("assessments.soft_skils_desc") }}</p>
        </div>
      </div>
    </b-container>

    <div id="blue-bg-container" class="py-5">
      <b-container class="text-center">
        <h5 class="text-primary mt-3 mb-4">
          {{ trans("assessments.what_we_mesure") }}
        </h5>
        <p class="mb-5">{{ trans("assessments.what_we_mesure_desk") }}</p>
        <div>
          <b-img :src="trans('assessments.competences')" class="d-none d-md-inline-flex" fluid />
          <b-img :src="trans('assessments.competences_mobile')" class="d-md-none" fluid />
        </div>
      </b-container>
    </div>
    <b-container class="p-5">
      <div class="px-md-5">
        <h5 class="text-primary mt-3 mb-4">
          {{ trans("assessments.initial_evaluation") }}
        </h5>
        <ul class="pl-3">
          <li class="pb-4">
            {{ trans("assessments.initial_evaluation_desc") }}
          </li>
          <li class="pb-4">
            {{ trans("assessments.initial_evaluation_desc_2") }}
          </li>
        </ul>

        <h5 class="text-primary mt-5 mb-4">
          {{ trans("assessments.final_evaluation") }}
        </h5>
        <ul class="pl-3">
          <li class="pb-4">
            {{ trans("assessments.final_evaluation_desc") }}
          </li>
          <li class="pb-4">
            {{ trans("assessments.final_evaluation_desc_2") }}
          </li>
          <li class="pb-4">
            {{ trans("assessments.final_evaluation_desc_3") }}
          </li>
        </ul>

        <h6 class="text-primary mt-4 mb-4">
          {{ trans("assessments.using_LB_learning_method") }}<br />
          <br />
          {{ trans("assessments.what_are_you_waiting") }}
        </h6>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            :href="autoLoginUrl"
            target="_blank"
            @click="trackStartTest"
            >{{ trans("assessments.start_test") }}</b-button
          >
        </div>
      </div>
    </b-container>

    <b-container class="px-4 pb-5">
      <hr class="mb-5" />
      <h5 class="text-primary mt-3 mb-4">
        {{ trans("assessments.competence_center") }}
      </h5>

      <div class="row pb-5">
        <div class="col-12 col-md-7">
          <p>
            {{ trans("assessments.competence_desc") }}
            <br />
            {{ trans("assessments.competence_desc_2") }}
          </p>
          <div class="d-flex justify-content-end">
            <b-button variant="secondary" href="https://www.unive.it/pag/29992" target="_blank">{{
              trans("assessments.visit_the_website")
            }}</b-button>
          </div>
        </div>
        <div class="col-12 col-md-5 text-center">
          <b-img class="cfcc-logo-big" src="/images/CFCC_logo 2.png" />
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <scroll-top-button variant="outline-secondary" />
      </div>
    </b-container>
  </div>
</template>

<script>
import AssessmentsCards from "../organisms/AssessmentsCards";
import ScrollTopButton from "../atoms/ScrollTopButton";
import ServiceIntro from "../organisms/ServiceIntro";
import MenuContainer from "../organisms/menu/MenuContainer";

export default {
  name: "AssessmentsContainer",
  components: {
    AssessmentsCards,
    ScrollTopButton,
    ServiceIntro,
    MenuContainer,
  },
  data() {
    return {
      assessmentsAvailable: false,
      statusFirstTest: 0,
      isSecondTestAvailable: 0,
      statusSecondTest: 0,
      autoLoginUrl: "",
      dateCompletedFirst: "",
      dateCompletedSecond: "",
    };
  },
  mounted() {
    trackEvent("GoToAssessment", {});
    window.scrollTo(0, 0);
    this.getAssessmentState();
  },
  methods: {
    getAssessmentState() {
      this.$axios
        .get("/api/rest/user/assessment")
        .then((response) => {
          this.assessmentsAvailable = response.data.hasData;
          if (this.assessmentsAvailable) {
            this.statusFirstTest = response.data.data.status_first_test;
            this.isSecondTestAvailable = response.data.data.is_second_test_available;
            this.statusSecondTest = response.data.data.status_second_test;
            this.autoLoginUrl = response.data.url;
            this.dateCompletedFirst = response.data.data.date_completed_first;
            this.dateCompletedSecond = response.data.data.date_completed_second;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    trackStartTest() {
      trackEvent("StartAssessment_undefined", {});
    },
  },
};
</script>

<style scoped lang="scss">
#blue-bg-container {
  background: #f1f5ff;
}

.cfcc-logo-big {
  max-width: 220px;
}

.logo-cfcc-small {
  background: $color-white;
  @include border-radius(0.25rem);
  flex-direction: column;
  text-align: left;

  img {
    max-width: 150px;
  }
}
</style>
